import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class CompanyWorksRequest extends GenericRequest {

    company_id;
    not_check_presencia_obra;
    presence_type_id; // number
    level_type_id; // number

    constructor(company_id, presenceTypeId, levelTypeId, notCheckPresenciaObra = false, term = '') {
        super(METHOD_POST, ApiEndpoints.WORKS);

        this.company_id = company_id;
        this.term = term;
        this.not_check_presencia_obra = notCheckPresenciaObra;
        this.presence_type_id = presenceTypeId;
        this.level_type_id = levelTypeId;
    }

    overrideRequest() {
        const request = {};
        request.retrieve_construction_contracts = false;
        request.criteria = {};
        if ( this.company_id ) request.criteria.company_id = this.company_id;
        if ( this.term ) request.criteria.term = this.term;
        if ( this.not_check_presencia_obra ) request.criteria.not_check_presencia_obra = this.not_check_presencia_obra;
        if (this.presence_type_id && this.presence_type_id !== -1) {
            request.criteria.presence_type_id = this.presence_type_id;
        }
        if (this.level_type_id && this.level_type_id !== -1) {
            request.criteria.level_type_id = this.level_type_id;
        }
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/outsource/ws/CompanyWorksRequest.js